import dialogPolyfill from 'dialog-polyfill';

/**
 * Video Blocks
 *
 * Generates a dialog element for the video modal when the video block is clicked
 *
 * @return {void}
 */
function initVideoBlocks() {
	const videoBlocks = document.querySelectorAll('.paragon-video-block');

	if (!videoBlocks) {
		return;
	}

	videoBlocks.forEach((videoBlock) => {
		const openModal = videoBlock.querySelector('.play-video-button');
		const modal = videoBlock.querySelector('.video-modal');
		const modalContent = videoBlock.querySelector('.video-modal-content');

		if (!openModal || !modal || !modalContent) {
			return;
		}

		dialogPolyfill.registerDialog(modal);

		const url = videoBlock.querySelector('.video-wrapper')?.dataset.link;
		const iframe = document.createElement('iframe');
		openModal.addEventListener('click', function onOpen() {
			// .showModal() is part of the HTMLDialogElement API
			modal.showModal();

			iframe.setAttribute('frameborder', '0');
			iframe.setAttribute('allow', 'autoplay; encrypted-media;');
			iframe.setAttribute('allowfullscreen', 'true');

			// set the iframe src and extra attributes based on the media type
			const mediaType = url.includes('youtu') ? 'youtube' : 'vimeo';
			const videoId = url.split('/').pop();
			if (mediaType === 'youtube') {
				iframe.setAttribute(
					'src',
					'https://www.youtube.com/embed/' + videoId + '?autoplay=1'
				);
			}
			if (mediaType === 'vimeo') {
				iframe.setAttribute(
					'src',
					'https://player.vimeo.com/video/' + videoId + '?autoplay=1'
				);
				iframe.setAttribute('width', '100%');
				iframe.setAttribute('height', '100%');
			}
			modalContent.appendChild(iframe);

			// add the media element that contains the video to the modal
			modal.appendChild(modalContent);
		});

		modal.addEventListener('close', function onClose() {
			// "Close" button inside the form triggers "close" on dialog because of [method="dialog"]
			modal.removeChild(modalContent);
		});
	});
}

document.addEventListener('DOMContentLoaded', function () {
	initVideoBlocks();
});
